function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import t from "@swup/plugin";
import { Location as e, getCurrentUrl as r } from "swup";
function o(t, r) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$stripEmptyParams = _ref.stripEmptyParams,
    o = _ref$stripEmptyParams === void 0 ? !1 : _ref$stripEmptyParams;
  var s = n("method", t, r),
    i = n("enctype", t, r),
    a = "multipart/form-data" === i,
    u = n("target", t, r, ""),
    _e$fromUrl = e.fromUrl(n("action", t, r)),
    m = _e$fromUrl.origin,
    c = _e$fromUrl.href,
    l = new FormData(t, r);
  var h, f;
  if ("POST" === s && (h = a ? l : new URLSearchParams(l)), "GET" === s) {
    var _t = o ? function (t) {
      var e = new FormData();
      for (var _i = 0, _Array$from = Array.from(t.entries()); _i < _Array$from.length; _i++) {
        var _Array$from$_i = _slicedToArray(_Array$from[_i], 2),
          _r = _Array$from$_i[0],
          _o = _Array$from$_i[1];
        "" !== _o && e.append(_r, _o);
      }
      return e;
    }(l) : l;
    f = function (t, e) {
      var _ref2 = [].concat(_toConsumableArray(t.split(/(?=#)/)), [""]),
        r = _ref2[0],
        o = _ref2[1],
        n = r.split("?")[0],
        s = new URLSearchParams(e).toString();
      return s ? "".concat(n, "?").concat(s).concat(o) : n + o;
    }(c, _t);
  } else f = c;
  var _e$fromUrl2 = e.fromUrl(f),
    p = _e$fromUrl2.url,
    d = _e$fromUrl2.hash;
  return {
    origin: m,
    action: c,
    href: f,
    url: p,
    hash: d,
    method: s,
    target: u,
    data: l,
    body: h,
    encoding: i
  };
}
function n(t, e, o, n) {
  var _ref3, _o$getAttribute;
  return function (t, e) {
    switch (t) {
      case "action":
        return e !== null && e !== void 0 ? e : r();
      case "method":
        return (e || "get").toUpperCase();
      case "enctype":
        return (e || "application/x-www-form-urlencoded").toLowerCase();
      default:
        return e !== null && e !== void 0 ? e : null;
    }
  }(t, (_ref3 = (_o$getAttribute = o === null || o === void 0 ? void 0 : o.getAttribute("form".concat(t))) !== null && _o$getAttribute !== void 0 ? _o$getAttribute : e.getAttribute(t)) !== null && _ref3 !== void 0 ? _ref3 : n);
}
var s = /*#__PURE__*/function (_t2) {
  _inherits(s, _t2);
  var _super = _createSuper(s);
  function s() {
    var _this;
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, s);
    _this = _super.call(this), _this.name = "SwupFormsPlugin", _this.requires = {
      swup: ">=4"
    }, _this.defaults = {
      formSelector: "form[data-swup-form]",
      inlineFormSelector: "form[data-swup-inline-form]",
      stripEmptyParams: !1
    }, _this.options = void 0, _this.specialKeys = void 0, _this.formSubmitDelegate = void 0, _this.prepareInlineForms = function (t) {
      var e = t.trigger.el;
      if (!(e !== null && e !== void 0 && e.matches(_this.options.inlineFormSelector))) return;
      if (!e.id) return void console.error("[@swup/forms-plugin] inline forms must have an id attribute:", e);
      var r = "#".concat(e.id);
      t.containers = [r], t.animation.scope = "containers", t.animation.selector = r, t.scroll.target = r;
      var o = t.a11y;
      "object" == _typeof(o) && (o.focus = r);
    }, _this.options = _objectSpread(_objectSpread({}, _this.defaults), t), _this.specialKeys = function (t) {
      var e = {};
      function r() {
        e = {};
      }
      function o(_ref4) {
        var r = _ref4.key;
        t.includes(r) && (e[r] = !0);
      }
      function n(_ref5) {
        var r = _ref5.key;
        t.includes(r) && (e[r] = !1);
      }
      function s() {
        r();
      }
      return {
        watch: function watch() {
          document.addEventListener("keydown", o), document.addEventListener("keyup", n), window.addEventListener("blur", s);
        },
        unwatch: function unwatch() {
          document.removeEventListener("keydown", o), document.removeEventListener("keyup", n), document.removeEventListener("blur", s), r();
        },
        get pressed() {
          return Object.values(e).filter(Boolean).length > 0;
        }
      };
    }(["Meta", "Control", "Shift"]), _this.beforeFormSubmit = _this.beforeFormSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(s, [{
    key: "mount",
    value: function mount() {
      this.swup.hooks.create("form:submit"), this.swup.hooks.create("form:submit:newtab"), this.specialKeys.watch(), this.formSubmitDelegate = this.swup.delegateEvent(this.options.formSelector, "submit", this.beforeFormSubmit, {
        capture: !0
      }), this.on("visit:start", this.prepareInlineForms, {
        priority: 1
      });
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var _this$formSubmitDeleg;
      (_this$formSubmitDeleg = this.formSubmitDelegate) !== null && _this$formSubmitDeleg !== void 0 && _this$formSubmitDeleg.destroy(), this.specialKeys.unwatch();
    }
  }, {
    key: "beforeFormSubmit",
    value: function beforeFormSubmit(t) {
      var _this2 = this;
      var e = this.swup,
        r = t.delegateTarget,
        n = t.submitter,
        _o2 = o(r, n),
        _s2 = _o2.href,
        i = _o2.url,
        a = _o2.hash,
        u = _o2.target,
        m = this.specialKeys.pressed,
        c = "_blank" === u,
        l = m || c,
        h = e.createVisit({
          to: i,
          hash: a,
          el: r,
          event: t
        });
      if (l || !e.shouldIgnoreVisit(_s2, {
        el: r,
        event: t
      })) if (c) e.hooks.callSync("form:submit:newtab", h, {
        el: r,
        event: t
      });else if (m) {
        e.hooks.callSync("form:submit:newtab", h, {
          el: r,
          event: t
        });
        var _o3 = function (t) {
          var e = t.getAttribute("target") || "";
          return t.setAttribute("target", "_blank"), function () {
            e ? t.setAttribute("target", e) : t.removeAttribute("target");
          };
        }(r);
        r.addEventListener("submit", function () {
          return setTimeout(_o3);
        }, {
          once: !0
        });
      } else e.hooks.callSync("form:submit", h, {
        el: r,
        event: t
      }, function () {
        _this2.submitForm(t);
      });
    }
  }, {
    key: "submitForm",
    value: function submitForm(t) {
      var e = t.delegateTarget,
        r = t.submitter,
        n = this.options.stripEmptyParams,
        _o4 = o(e, r, {
          stripEmptyParams: n
        }),
        _s3 = _o4.href,
        i = _o4.method,
        a = _o4.body;
      ["GET", "POST"].includes(i) ? (t.preventDefault(), this.swup.navigate(_s3, {
        method: i,
        body: a,
        cache: {
          read: !1,
          write: !0
        }
      }, {
        el: e,
        event: t
      })) : console.warn("Unsupported form method: ".concat(i));
    }
  }]);
  return s;
}(t);
export { s as default };